import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=62f21a12"
import script from "./RequestList.vue?vue&type=script&lang=js"
export * from "./RequestList.vue?vue&type=script&lang=js"
import style0 from "./RequestList.vue?vue&type=style&index=0&id=62f21a12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports